import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from 'react-aria-components';
import { RouterProvider } from 'react-router/dom';
import { router } from './app/router';
import { ApiError } from './lib/api';
import { ConfirmProvider } from './ui/dialog';
import { ToastProvider } from './ui/toast';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        failureCount < 2 &&
        !(error instanceof ApiError && error.status >= 400 && error.status < 500),
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('The root element is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider locale="nl-NL">
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ConfirmProvider>
            <RouterProvider router={router} />
          </ConfirmProvider>
        </ToastProvider>
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
